import Vue from "vue";
import Vuex from "vuex";
import { firebase } from "../firebase/firebase";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userData: {},
    courseData: [],
    outpatientData: [],
  },
  getters: {
    userData: (state) => state.userData,
    courseData: (state) => state.courseData,
    courseDataById: (state) => (id) =>
      state.courseData.find((x) => x.id === id),
    outpatientData: (state) => state.outpatientData,
    outpatientDataById: (state) => (id) =>
      state.outpatientData.find((x) => x.id === id),
  },
  mutations: {
    SET_USERDATA: (state, data) => (state.userData = data),
    SET_COURSEDATA: (state, data) => (state.courseData = data),
    SET_OUTPATIENTDATA: (state, data) => (state.outpatientData = data),
    setQuestion: (state, { questionData, id }) => {
      setTimeout(() => {
        state.outpatientData.find((x) => x.id === id)["questionData"] =
          questionData;
      }, 100);
    },
    UPDATE_USERDATA: (state, data) => Object.assign(state.userData, data),
  },
  actions: {
    initAllCourse({ commit, state }) {
      if (state.courseData.length !== 0) return;
      firebase
        .firestore()
        .collection("course")
        .onSnapshot((snap) => {
          const data = snap.docs
            .map((x) => {
              let snapData = x.data();
              snapData.id = x.id;
              return snapData;
            })
            .filter((x) => x.launched);
          commit("SET_COURSEDATA", data);
        });
    },

    initAllOutpatient({ commit, state }) {
      if (state.outpatientData.length !== 0) return;
      return firebase
        .firestore()
        .collection("outpatient")
        .onSnapshot((snap) => {
          const data = snap.docs
            .map((x) => {
              let snapData = x.data();
              snapData.id = x.id;
              if (snapData.questionData) {
                snapData.questionData = snapData.questionData.map((x) => {
                  if (x.type === "checkbox" || x.type === "radio") {
                    x.item = x.item.split("&");
                  }
                  if (x.type === "checkbox") {
                    x.message = [];
                  } else x.message = "";
                  return x;
                });
              }

              return snapData;
            })
            .filter((x) => x.launched);
          commit("SET_OUTPATIENTDATA", data);
        });
    },

    async checkEnroll({ state }, sendData) {
      if (!state.userData.phone) return { has: -1 };

      const { type, typeID, date, limit, dateStartTime, dateEndTime } =
        sendData;
      const snap = await firebase
        .firestore()
        .collection(type)
        .doc(typeID)
        .collection("enroll")
        // .where('userId', '==', state.userData.userId)
        .where("date", "==", date)
        .where("dateStartTime", "==", dateStartTime)
        .where("dateEndTime", "==", dateEndTime)
        .orderBy("createTime", "asc")
        .get();

      // 0 => 沒有報名過 1=>報名過 2=>報名過且取消 無法再報名
      const enrollData = snap.docs.map((x) => {
        let data = x.data();
        data["id"] = x.id;
        return data;
      });
      const userIdIndex = enrollData.findIndex(
        (x) => x.userId === state.userData.userId
      );
      if (userIdIndex === -1) {
        return { has: 0, length: enrollData.length };
      }
      if (limit < userIdIndex) {
        return {
          has: 2,
          id: enrollData[userIdIndex]["id"],
          length: enrollData.length,
        };
      } else {
        return {
          has: 1,
          id: enrollData[userIdIndex]["id"],
          length: enrollData.length,
        };
      }
    },

    async activityEnroll({ state }, sendData) {
      let createTime = firebase.firestore.Timestamp.now();
      let {
        userId,
        displayName,
        name,
        phone,
        email,
        IDnumber,
        companyName = "",
      } = state.userData;
      console.log(132, state.userData);

      //@type => 活動類型 ex 門診 or 課程
      //@typeID =>  門診ID or 課程ID
      let {
        type,
        typeID,
        date,
        dateStartTime,
        dateEndTime,
        department,
        activeName,
        index,
        info = "",
        question = "",
      } = sendData;
      return new Promise((resolve) => {
        const ref = firebase.firestore().collection(type).doc(typeID);
        return firebase.firestore().runTransaction((transation) => {
          return transation.get(ref).then((doc) => {
            if (!doc.exists) {
              throw "error";
            }
            let newData = doc.data();
            if (!newData["availableTime"][index]["joinNumber"]) {
              newData["availableTime"][index]["joinNumber"] = 1;
            } else {
              ++newData["availableTime"][index]["joinNumber"];
              // let newJoinNumber = ++newData['availableTime'][index]['joinNumber']
              // if (newJoinNumber > newData['availableTime'][index]['limit']) {
              //   return Promise.reject('錯誤,超過人數')
              // }
            }

            transation.update(ref, newData);
            firebase
              .firestore()
              .collection(type)
              .doc(typeID)
              .collection("enroll")
              .add({
                companyName,
                userId,
                displayName,
                name,
                phone,
                email,
                IDnumber: IDnumber ?? "",
                date,
                dateStartTime,
                dateEndTime,
                createTime,
                department,
                activeName,
                info,
                question,
              })
              .then((data) => {
                firebase
                  .firestore()
                  .collection(type)
                  .doc(typeID)
                  .collection("enroll")
                  .where("dateStartTime", "==", dateStartTime)
                  .where("dateEndTime", "==", dateEndTime)
                  .get()
                  .then((snap) => {
                    resolve({
                      id: data.id,
                      num: snap.docs.length,
                    });
                  });
              });
          });
        });
      });
    },

    async activityEnrollCancel(state, sendData) {
      //@type => 活動類型 ex 門診 or 課程
      //@typeID =>  門診ID or 課程ID
      let { type, typeID, index, cancelId } = sendData;
      console.log(type, typeID, index, cancelId);
      const ref = firebase.firestore().collection(type).doc(typeID);
      return firebase.firestore().runTransaction((transation) => {
        return transation.get(ref).then((doc) => {
          if (!doc.exists) {
            throw "error";
          }
          let newData = doc.data();
          --newData["availableTime"][index]["joinNumber"];

          transation.update(ref, newData);
          // firebase.firestore().collection(type).doc(typeID).collection('enroll').doc(cancelId).update({cancel:true})
          firebase
            .firestore()
            .collection(type)
            .doc(typeID)
            .collection("enroll")
            .doc(cancelId)
            .delete();
          return true;
        });
      });
    },
  },
  modules: {},
});
